'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var domModule = weex.requireModule('dom');
exports.default = {
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stylesConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showLine: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      componentWidth: 750,
      activeIndex: -1,
      linePos: []
    };
  },

  watch: {
    list: function list(newVal) {
      var _this = this;

      this.$nextTick(function () {
        setTimeout(function () {
          _this.init();
        }, 100);
      });
    }
  },
  computed: {
    formattedList: function formattedList() {
      var formattedList = this.formatList(this.list);
      return formattedList;
    },
    rowStyles: function rowStyles() {
      var _stylesConfig$rowStyl = this.stylesConfig.rowStyles,
          rowStyles = _stylesConfig$rowStyl === undefined ? {} : _stylesConfig$rowStyl;

      //处理行

      return _extends({}, rowStyles);
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      this.list.forEach(function (item) {
        _this2.linePos.push({ width: 0 });
      });
      // 确定第一条线的左边距离
      if (this.linePos.length > 0) {
        domModule.getComponentRect(this.$refs['item0'][0], function (data) {
          _this2.linePos[0]['margin-left'] = data.size.width / 2 + 8 + 'px';
        });
      }
      this.list.forEach(function (item, index, arr) {
        // 确定条线的宽度
        domModule.getComponentRect(_this2.$refs['point' + index][0], function (data) {
          if (index == 0) {
            _this2.linePos[index]['data-right'] = data.size.right;
          } else {
            _this2.linePos[index]['data-right'] = data.size.right;
            _this2.linePos[index - 1]['width'] = data.size.left - _this2.linePos[index - 1]['data-right'] + 'px';
          }
        });
      });
    },
    formatList: function formatList(list) {
      var _this3 = this;

      var tempList = JSON.parse(JSON.stringify(list));
      var _stylesConfig = this.stylesConfig,
          _stylesConfig$actived = _stylesConfig.activedColor,
          activedColor = _stylesConfig$actived === undefined ? '#00de51' : _stylesConfig$actived,
          _stylesConfig$pointSt = _stylesConfig.pointStyles,
          pointStyles = _stylesConfig$pointSt === undefined ? {} : _stylesConfig$pointSt,
          _stylesConfig$lineSty = _stylesConfig.lineStyles,
          lineStyles = _stylesConfig$lineSty === undefined ? {} : _stylesConfig$lineSty,
          _stylesConfig$descSty = _stylesConfig.descStyles,
          descStyles = _stylesConfig$descSty === undefined ? {} : _stylesConfig$descSty,
          _stylesConfig$columnS = _stylesConfig.columnStyles,
          columnStyles = _stylesConfig$columnS === undefined ? {} : _stylesConfig$columnS;


      tempList.forEach(function (item, index) {
        if (item.isActived) _this3.activeIndex = index;
      });

      var result = [];
      result = tempList.map(function (item, index) {
        //处理列
        item['columnStyles'] = _extends({}, item['columnStyles'], columnStyles);

        //处理节点point
        item['pointStyles'] = _extends({}, item['pointStyles'], pointStyles);

        if (index <= _this3.activeIndex) {
          item['pointStyles']['background-color'] = activedColor;
          item['pointStyles']['opacity'] = 1;
        }

        //处理节点线条
        item['lineStyles'] = _extends({}, item['lineStyles'], lineStyles);
        if (index < _this3.activeIndex) {
          item['lineStyles']['border-top-color'] = activedColor;
          item['lineStyles']['opacity'] = 1;
        }

        //处理内容
        item['descStyles'] = _extends({}, item['descStyles'], descStyles);
        if (item.isActived && activedColor) {
          item['descStyles']['color'] = activedColor;
          item['descStyles']['opacity'] = 1;
        }

        return item;
      });

      return result;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$nextTick(function () {
      setTimeout(function () {
        _this4.init();
      }, 100);
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-step-flow-h/index.vue
// module id = 401
// module chunks = 0 1